import { AxiosInstance } from 'axios'
import { TeamDetailsData } from '@dc-shared-web/hooks/api/team'

export type GetTeamQueryParams = {
  teamUUID?: string | null
}

export const fetchTeamByUUID = async (
  apiClient: AxiosInstance,
  params?: GetTeamQueryParams
): Promise<TeamDetailsData> => {
  const res = await apiClient.get(`/api/teams/${params?.teamUUID}`, {
    params,
  })

  return res.data.data
}
